import React from 'react';
import { motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/pack';
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <motion.section id={id} initial={{
  opacity: 0,
  y: 24
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-80px'
}} transition={{
  duration: 0.5,
  ease: [0.23, 1, 0.32, 1]
}} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-209" data-mp="137dpns1v4o0v">
    {children}
  </motion.section>;
export const SectionTitle = ({
  children,
  eyebrow,
  lead,
  className = ''
}: {
  children: React.ReactNode;
  eyebrow?: string;
  lead?: string;
  className?: string;
}) => <div className={`mb-12 text-center ${className}`} data-id="element-210" data-mp="pcl1k57wpzio">
    {eyebrow && <span className="mb-3 block font-display text-[10px] font-semibold uppercase tracking-[0.32em] text-brand-goldDark md:text-xs" data-id="element-211" data-mp="1vtyjcz5t9c7l">
        {eyebrow}
      </span>}
    <h2 className="mx-auto max-w-3xl font-serif text-3xl font-semibold leading-tight text-brand-burgundy md:text-5xl" data-id="element-212" data-mp="39kj0tmcreupo">
      {children}
    </h2>
    {lead && <p className="mx-auto mt-4 max-w-2xl font-serif text-lg italic text-brand-textLight/85 md:text-xl" data-id="element-213" data-mp="34j3ja49sj6c1">
        {lead}
      </p>}
  </div>;
export const CTAButton = ({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'cinnabar'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'cinnabar' | 'bronze';
}) => {
  const bgClass = variant === 'cinnabar' ? 'bg-brand-burgundy hover:bg-brand-burgundyDark' : 'bg-brand-gold hover:bg-brand-goldDark';
  return <motion.a href={href} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-sm px-8 py-4 font-display text-sm font-semibold uppercase tracking-[0.18em] text-brand-surface transition-colors duration-200 ease-out ${bgClass} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-214" data-mp="2cvbhmkzm4xox">
      {children}
    </motion.a>;
};